import { useDroppable } from "@dnd-kit/core"
import { horizontalListSortingStrategy, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import React from "react"
import SortableItem from "./SortableItem"
import { useLesson } from "../../hooks/lesson-context"

export const MatchColumnsDroppable = ({
  id,
  items,
  className,
  children,
  noBorder = false,
  vertical = false,
  ...rest
}) => {
  const { state: ctxState, dispatch: ctxDispatch } = useLesson()
  const combinedClassName = `dropzone ${className || ""} ${items?.length === 0 && !noBorder ? "empty" : ""}`

  const { setNodeRef } = useDroppable({
    disabled: ctxState?.actionRunning,
    id,
  })
  return (
    <SortableContext
      id={id}
      items={items}
      strategy={vertical ? verticalListSortingStrategy : horizontalListSortingStrategy}
    >
      <div {...rest} className={combinedClassName} ref={setNodeRef}>
        {items.map((item, i) => (
          <SortableItem
            //
            item={item}
            key={`${i}-${item?.uid}`}
            id={item}
            style={
              vertical
                ? {
                    margin: "0",
                  }
                : {}
            }
          />
        ))}
      </div>
    </SortableContext>
  )
}
